import { gql } from "@apollo/client";

export const GET_TRAINING_MODULES_LIBRARY = gql`
  query GetTrainingModulesLibrary($page: Int, $limit: Int) {
    getTrainingModulesLibrary(page: $page, limit: $limit) {
      success
      message
      totalCount
      currentPage
      totalPages
      data {
        id
        title
        description
        created_at
        updated_at
        is_added
        sections {
          id
          prereq_section_id
          section_type_id
          title
          description
          path
          sort_order
          created_at
          updated_at
          section_type_key
        }
      }
    }
  }
`;

export const UPDATE_TRAINING_MODULE_STATUS = gql`
  mutation UpdateTrainingModuleStatus($id: Int!, $status_id: Int!) {
    updateTrainingModuleStatus(id: $id, status_id: $status_id) {
      success
      message
      data {
        id
        title
        description
        status_title
      }
    }
  }
`;

export const GET_TRAINING_MODULES = gql`
  query GetTrainingModules(
    $filter: TrainingModuleFilterInput
    $page: Int
    $limit: Int
  ) {
    getTrainingModules(filter: $filter, page: $page, limit: $limit) {
      success
      message
      totalCount
      currentPage
      totalPages
      data {
        id
        title
        description
        status_id
        status_title
        status_key
        created_at
        updated_at
      }
    }
  }
`;

export const GET_TRAINING_MODULE_BY_ID = gql`
  query GetTrainingModuleById($id: Int!) {
    getTrainingModuleById(id: $id) {
      success
      message
      data {
        id
        title
        description
        status_title
        sections {
          id
          title
          description
          path
          metadata
          sort_order
          section_type_id
          section_type_key
        }
      }
    }
  }
`;

export const UPDATE_TRAINING_SECTION_PROGRESS = gql`
  mutation UpdateTrainingSectionProgress(
    $training_section_id: Int!
    $status_id: Int!
  ) {
    updateTrainingSectionProgress(
      training_section_id: $training_section_id
      status_id: $status_id
    ) {
      success
      message
      data {
        employee_email
        training_section_id
        status_id
        updated_at
      }
    }
  }
`;

export const ADD_TRAINING_MODULE_FROM_LIBRARY = gql`
  mutation AddTrainingModuleFromLibrary($training_module_ids: [Int!]!) {
    addTrainingModuleFromLibrary(training_module_ids: $training_module_ids) {
      success
      message
    }
  }
`;

export const GET_EMPLOYEE_TRAINING_MODULE_BY_ID = gql`
  query GetEmployeeTrainingModuleById($id: Int!) {
    getEmployeeTrainingModuleById(id: $id) {
      success
      message
      data {
        id
        title
        description
        status_id
        status_title
        created_at
        updated_at
        completion_status_key
        total_sections
        completed_sections
        sections {
          id
          prereq_section_id
          title
          description
          path
          metadata
          sort_order
          section_type_key
          progress_status_id
          progress_status_title
          progress_status_key
          created_at
          updated_at
        }
      }
    }
  }
`;

export const GET_EMPLOYEE_TRAINING_MODULES = gql`
  query GetEmployeeTrainingModules($page: Int, $limit: Int) {
    getEmployeeTrainingModules(page: $page, limit: $limit) {
      success
      message
      data {
        id
        title
        description
        status_id
        status_title
        created_at
        updated_at
        completion_status_key
        total_sections
        completed_sections
      }
      totalCount
      currentPage
      totalPages
    }
  }
`;

export const GET_EMPLOYEE_TRAINING_SECTION_BY_ID = gql`
  query GetEmployeeTrainingSectionById($id: Int!) {
    getEmployeeTrainingSectionById(id: $id) {
      success
      message
      data {
        id
        title
        description
        path
        metadata
        sort_order
        section_type_key
        progress_status_id
        progress_status_title
        progress_status_key
      }
    }
  }
`;
